import { AllProductSupplierOrgs } from '@kaiizen/kai-pro-api';
import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useKaiProApiClient } from '../useKaiProApiClient';

export const useAllProductSupplierOrgs = () => {
  const kaiProApiClient = useKaiProApiClient();

  const query = useCachedQuery(
    'allProductSupplierOrgs',
    () => kaiProApiClient.getAllProductSupplierOrgs(),
    { enabled: !!kaiProApiClient.token },
  );

  return {
    productSupplierOrgs: query.data as AllProductSupplierOrgs | undefined,
    productSuppliersLoading: query.isLoading,
  };
};
